export enum BrokerStatusType {
    Pending = 0,
    InviteSent = 1,
    InviteAccepted = 2,
    Activated = 3,
    Rejected = 4,
}

export const BrokerStatusTypeOptions = [
    {
        id: BrokerStatusType.Pending,
        name: 'Pending',
        shortName: 'Pending',
    },
    {
        id: BrokerStatusType.InviteSent,
        name: 'Invite sent to Broker',
        shortName: 'Invite Sent',
    },
    {
        id: BrokerStatusType.InviteAccepted,
        name: 'Invite Accepted by Broker',
        shortName: 'Invite Accepted',
    },
    {
        id: BrokerStatusType.Activated,
        name: 'Activated',
        shortName: 'Activated',
    },
    {
        id: BrokerStatusType.Rejected,
        name: 'Rejected',
        shortName: 'Rejected',
    },
];
